module.exports = __webpack_public_path__ + "img/scz.c321e5a1.gif";